module.exports = __webpack_public_path__ + "img/vector-1@2x.f8bc98d5.png";